export const PostcardDesignIcon = () => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="32" height="32" rx="4" />
        <path
            d="M22.6824 11.2939H9.31772C9.1098 11.2939 8.94125 11.4625 8.94125 11.6704V20.3292C8.94125 20.5371 9.1098 20.7057 9.31772 20.7057H22.6824C22.8903 20.7057 23.0589 20.5371 23.0589 20.3292V11.6704C23.0589 11.4625 22.8903 11.2939 22.6824 11.2939Z"
            stroke="#5C5C5C"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.2941 16.9412H13.647"
            stroke="#5C5C5C"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.2941 18.8235H16.4705"
            stroke="#5C5C5C"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M20.9882 13.1765H18.5412C18.4372 13.1765 18.3529 13.2608 18.3529 13.3647V15.8118C18.3529 15.9158 18.4372 16 18.5412 16H20.9882C21.0922 16 21.1765 15.9158 21.1765 15.8118V13.3647C21.1765 13.2608 21.0922 13.1765 20.9882 13.1765Z"
            stroke="#5C5C5C"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
